import { TabContext, TabList } from '@mui/lab';
import { CustomTab, StickyTabBox } from 'components/pages/Competition/competitionPage.styles';
import CompetitionTabContent, { TabItems } from 'components/pages/Competition/CompetitionTabs/CompetitionTabContent';
import { Box } from '@mui/material';
import useTabState from 'hooks/useTabeState';
import withRestrictions from 'components/hoc/withRestrictions';
// import HeaderBanner from 'components/system/HeaderBanner';

const RestrictedCompetitionTabContent = withRestrictions(CompetitionTabContent);

const CompetitionTabs = ({ definitionLink, rulesLink, isLeaderboardVisible }) => {
  const { selectedTab, handleTabChange } = useTabState('overview');
  return (
    <Box>
      <TabContext value={selectedTab}>
        <StickyTabBox>
          {/* <HeaderBanner */}
          {/*  actionType="link" */}
          {/*  actionHandler="https://www.twitch.tv/bluequbitlive" */}
          {/*  announcement="Tune in 3:45pm ET, April 13th for the closing ceremony + awards with Scott Aaronson → " */}
          {/*  callForAction="https://www.twitch.tv/bluequbitlive" */}
          {/*  type="announcement" */}
          {/* /> */}
          <TabList
            onChange={handleTabChange}
            aria-label="hackathon tabs"
            centered
          >
            <CustomTab label="Overview" value={TabItems.OVERVIEW} />
            {!!isLeaderboardVisible && <CustomTab label="Rules" value={TabItems.RULES} />}
            <CustomTab label="Problems" value={TabItems.PROBLEMS} />
            {!!isLeaderboardVisible && <CustomTab label="Leaderboard" value={TabItems.LEADERBOARD} />}
            <CustomTab label="Submissions" value={TabItems.SUBMISSIONS} />
          </TabList>
        </StickyTabBox>
        <Box>
          <RestrictedCompetitionTabContent
            selectedTab={selectedTab}
            definitionLink={definitionLink}
            rulesLink={rulesLink}
          />
        </Box>
      </TabContext>
    </Box>
  );
};
export default CompetitionTabs;
